import React, { useRef, useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import DismissButton from '../../../../../../../components/global/DismissButton';
import Button from '../../../../../../../components/global/Button';
import { isIOS } from '../../../../../../../util/device-detector';
import withModal from '../../../../../../../components/global/modal/withModal';

const propTypes = {
  onClose: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  defaultValue: PropTypes.string,
  title: PropTypes.string,
  maxLength: PropTypes.number,
};

const TextEditorModal = ({
  onClose,
  onChange,
  defaultValue,
  title,
  maxLength = 25,
}) => {
  const [text, setText] = useState(defaultValue ?? '');
  const textarea = useRef();
  useEffect(() => {
    if (textarea.current) {
      textarea.current.focus();
      textarea.current.setSelectionRange?.(text.length, text.length);
    }
  }, []);

  return (
    <div className="card-element-text-control-content">
      <div className="card-element-control-header">
        <DismissButton onClick={onClose} />

        <span className="card-element-control-header-title">
          {title || 'Type your message…'}
        </span>

        <Button
          btnStyle="link"
          onClick={() => {
            onClose();
            onChange(text);
          }}
        >
          Done
        </Button>
      </div>

      <textarea
        cols="30"
        rows="10"
        className="card-element-text-control-textarea"
        ref={textarea}
        value={text}
        onChange={event => {
          const message = event.target.value;
          if (message.length <= maxLength) {
            setText(event.target.value);
          }
        }}
        onBlur={event => {
          // Best way we have right now to detect whether the "Done"
          // button on the mobile safari keyboard is pressed.
          if (!event.relatedTarget && isIOS()) {
            onChange(text);
            onClose();
          }
        }}
      />
    </div>
  );
};

TextEditorModal.propTypes = propTypes;

export const TEXT_EDITOR_MODAL = 'modal/TEXT_EDITOR';

export default withModal(TextEditorModal, {
  name: TEXT_EDITOR_MODAL,
  dismissible: false,
  size: 'xs',
  type: 'full',
  hideHeader: true,
  className: 'text-field-editor-modal',
});
